export const LOADING_OBJECTIVE_METRIC = "LOADING_OBJECTIVE_METRIC";
export const SAVE_LOADING_OBJECTIVE_METRIC = "SAVE_LOADING_OBJECTIVE_METRIC";
export const GET_OBJECTIVE_METRIC = "GET_OBJECTIVE_METRIC";
export const FORM_FAIL = "FORM_FAIL";
export const OBJECTIVE_METRIC_FAIL = "OBJECTIVE_METRIC_FAIL";
export const LOADING_OBJECTIVE_METRIC_BY_ID = "LOADING_OBJECTIVE_METRIC_BY_ID";
export const GET_OBJECTIVE_METRIC_BY_ID = "GET_OBJECTIVE_METRIC_BY_ID";

